import React, { Dispatch, SetStateAction } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';


interface TableProps {
    left: any[]
    right: any[]
    setLeft: Dispatch<SetStateAction<Product[]>>
    setRight: Dispatch<SetStateAction<Product[]>>
    handleUpdate: ((left: any, right: any) => void)
}

interface Product {
    id: number
    name: string
    description: string
    value: number
    image: string
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            margin: 'auto',
        },
        cardHeader: {
            padding: theme.spacing(1, 2),
        },
        list: {
            width: 300,
            height: 230,
            backgroundColor: theme.palette.background.paper,
            overflow: 'auto',
        },
        button: {
            margin: theme.spacing(0.5, 0),
        },
    }),
);

function not(a: Product[], b: Product[]) {
    return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a: Product[], b: Product[]) {
    return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a: Product[], b: Product[]) {
    return [...a, ...not(b, a)];
}

const TransferList: React.FC<TableProps> = ({ left, right, setLeft, setRight, handleUpdate }) => {
    const classes = useStyles();
    const [checked, setChecked] = React.useState<Product[]>([]);

    const leftChecked = intersection(checked, left);
    const rightChecked = intersection(checked, right);

    const handleToggle = (value: Product) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const numberOfChecked = (items: Product[]) => intersection(checked, items).length;

    const handleToggleAll = (items: Product[]) => () => {
        if (numberOfChecked(items) === items.length) {
            setChecked(not(checked, items));
        } else {
            setChecked(union(checked, items));
        }
    };

    const handleCheckedRight = () => {
        //@ts-ignore
        setRight(right.concat(leftChecked));
        //@ts-ignore

        setLeft(not(left, leftChecked));
        setChecked(not(checked, leftChecked));
    };

    const handleCheckedLeft = () => {
        //@ts-ignore
        setLeft(left.concat(rightChecked));
        //@ts-ignore
        setRight(not(right, rightChecked));
        setChecked(not(checked, rightChecked));
    };

    const customList = (title: React.ReactNode, items: Product[]) => (
        <Card>
            <CardHeader
                className={classes.cardHeader}
                avatar={
                    <Checkbox
                        onClick={handleToggleAll(items)}
                        checked={numberOfChecked(items) === items.length && items.length !== 0}
                        indeterminate={numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0}
                        disabled={items.length === 0}
                        inputProps={{ 'aria-label': 'all items selected' }}
                    />
                }
                title={title}
                subheader={`${numberOfChecked(items)}/${items.length} Selecionados`}
            />
            <Divider />
            <List className={classes.list} dense component="div" role="list">
                {items.map((value: Product) => {
                    const labelId = `transfer-list-all-item-${value}-label`;

                    return (
                        <ListItem key={value.id} role="listitem" button onClick={handleToggle(value)}>
                            <ListItemIcon>
                                <Checkbox
                                    checked={checked.indexOf(value) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ 'aria-labelledby': labelId }}
                                />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={value.name} />
                        </ListItem>
                    );
                })}
                <ListItem />
            </List>
        </Card>
    );

    return (
        <Grid container spacing={2} alignItems="center" className={classes.root}>
            <Grid item>{customList('Não inclusos', left)}</Grid>
            <Grid item>
                <Grid container direction="column" alignItems="center">
                    <Button
                        variant="outlined"
                        size="small"
                        className={classes.button}
                        onClick={handleCheckedRight}
                        disabled={leftChecked.length === 0}
                        aria-label="move selected right"
                    >
                        &gt;
          </Button>
                    <Button
                        variant="outlined"
                        size="small"
                        className={classes.button}
                        onClick={handleCheckedLeft}
                        disabled={rightChecked.length === 0}
                        aria-label="move selected left"
                    >
                        &lt;
          </Button>
                </Grid>
            </Grid>
            <Grid item>{customList('Inclusos', right)}</Grid>

            <Button
                variant="contained"
                color="secondary"
                style={{ margin: '10px 10px', width: '200px' }}
                onClick={() => { handleUpdate(left, right) }}
            >
                Atualizar Produtos Disponiveis
                    </Button>
        </Grid>

    );
}

export default TransferList